export default "__VITE_ASSET__BLM7NATX__"